import { SvgIconProps } from "@mui/material";

export const FourColumnsIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 2a1 1 0 0 1 1 1v18a1 1 0 0 1 -1 1a2 2 0 0 1 -2 -2v-16a2 2 0 0 1 2 -2" />
    <path d="M7 3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v18a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z" />
    <path d="M13 3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v18a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z" />
    <path d="M20 2a2 2 0 0 1 2 2v16a2 2 0 0 1 -2 2a1 1 0 0 1 -1 -1v-18a1 1 0 0 1 1 -1" />
  </svg>
);
